<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">
                    <!--考次-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">考次</label>
                            <div class="col-sm-9">
                                <select name="stlb" v-model="query.stlb" class="form-control">
                                    <option value="">-请选择-</option>
                                    <option v-for="item in examTime" :key="item.value" :value="item.value">{{item.text}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!--课程-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">课程</label>
                            <div class="col-sm-9">
                                <BootstrapCombobox
                                        :data="course"
                                        value-field="id"
                                        text-field="kcmc"
                                        v-model="query.kcId">
                                </BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--考生关键字-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">考生关键字</label>
                            <div class="col-sm-9">
                                <input type="text" name="keyword" v-model="query.keyword" class="form-control" placeholder="输入考生关键字">
                            </div>
                        </div>
                    </div>
                    <!--按钮-->
                    <div class="col-sm-12">
                        <div class="pull-right">
                            <button @click="search()" type="button" class="btn btn-primary btn-sm"
                                    style="margin-right:3px"><i class="fa fa-search" aria-hidden="true"></i>查询
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
                                    @onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    /**
     * 学业评价-学生观看情况
     */
    import tableMixin from '@/mixins/table.js';  //表格
    export default {
        mixins: [tableMixin],
        name: "StudentWatchConditionList",
        data: function () {
            return {
                // 考次
                examTime: [],
                // 课程
                course: [],
                query: {
                    // 考次
                    stlb: '',
                    // 课程
                    kc: '',
                    // 考生关键字
                    xmword: ''
                },
                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index) => {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'pxzt',
                        title: '考次',
                        // formatter: (value, row) => {
                        //     if (row.jgdm && row.jgmc) {
                        //         return row.jgdm + "-" + row.jgmc;
                        //     }
                        // }
                    },
                    {
                        field: 'xm',
                        title: '主考学校'
                    },
                    {
                        field: 'sfzh',
                        title: '试卷分类'
                    },
                    {
                        field: 'dwmc',
                        title: '试卷名称',
                    },
                    {
                        field: 'kcmc',
                        title: '课程名称'
                    },
                    {
                        field: 'kjsc',
                        title: '开放状态'
                    },
                    {
                        field: 'gksc',
                        title: '时间设定'
                    },
                    {
                        field: 'xxjd',
                        title: '考试时长'
                    },
                    {
                        field: 'fs',
                        title: '卷面总分'
                    },
                    {
                        field: 'fs',
                        title: '考试人数'
                    },
                ]
            }
        },
        mounted(){
            this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
            this.load();
        },
        beforeRouteUpdate(to, from, next){
            this.query = Object.assign(this.query,{current:1,size:10},to.query);
            this.load();
            next();
        },
        created: function () {
            this.$store.commit('setBreadcrumb', [{name: '自学考试'}, {name: '学业评价'}, {name: '作业列表'}]);
            this.getExamTime();
            this.getCourse();
        },
        methods: {
            // 考次
            getExamTime:function(){
                this.$http.post('').then(res=>{
                    this.examTime = res.data;
                });
            },
            // 课程
            getCourse: function () {
                this.$http.post("").then(res => {
                    this.kcList = res.data || [];
                });
            },
            search: function () {
                //将数据表格的页码以及每一页展示的数据重置为1，10
                let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
                this.$router.push({name:this.$route.name,query:query});
            },
            load: function (pageNumber, pageSize) {
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('', this.query).then(res => {
                    let data = res.data;
                    console.log(data)
                    //封装返回值
                    let result = {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
                    this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
                        pageSize:parseInt(this.query.size)});
                });
            },
            pageChange: function (pageNumber, pageSize) {
                let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
                this.$router.push({name:this.$route.name,query:query});
            }
        }
    }
</script>
<style scoped>

</style>
